// Daten-Hooks des Audit-Log-Viewers. Reines Lesen — keine Mutationen, keine Invalidierung nötig.
// staleTime: die Kette ist append-only und historische Monate ändern sich NIE — Monats-/Filter-Wechsel
// hin und zurück soll nicht jedes Mal neu über die Leitung (Review-Fund 16.07.).
import { useQuery } from '@tanstack/react-query'
import { api } from '../api/client'

const AUDIT_STALE_MS = 5 * 60_000

export function useAudit(from: string, to: string, action?: string) {
  return useQuery({
    queryKey: ['audit', from, to, action ?? ''] as const,
    queryFn: () => api.audit(from, to, action),
    staleTime: AUDIT_STALE_MS,
  })
}

/** Betreiber-Globalsicht (nur Superadmin — der Server erzwingt requireSuperadmin ohnehin). */
export function useAdminAudit(from: string, to: string, workshopId?: number) {
  return useQuery({
    queryKey: ['admin', 'audit', from, to, workshopId ?? 0] as const,
    queryFn: () => api.adminAudit(from, to, workshopId),
    staleTime: AUDIT_STALE_MS,
  })
}
